export function findApproval(approvals, criteria) {
  return approvals.find(approval => approval.criteria === criteria)
}



// WEBPACK FOOTER //
// ./src/utils/approval.js